import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux"

import { Field, reduxForm } from 'redux-form';

import agent from '../agent';
import FindMeForm from './FindMeForm';

import Countries from '../data/countries';
import CountryStates from '../data/states';

const ShowArtistSelection = ({artist, clientDetails, projectId, show, getCountryByCode, getStateById, checkArtist, isCheckingArtist}) => {
	return (
		<div key={artist.id} className={`findme-artist-item column column-block`}>
			<div className="find-artist-image"><img src={artist.photo || artist.photo_thumb} alt=""/></div>
			<div className="find-artist-name">{`${artist.first_name}  ${artist.last_name}`} </div>
			<div className="find-artist-type">{artist.artist_type}</div>
			<div className="find-artist-location">{`${getStateById(artist.state)}, ${getCountryByCode(artist.country)}`}</div>
			<button className="button" 
				disabled={isCheckingArtist}
				onClick={() => checkArtist(projectId, artist, 'find-me')}>
				{isCheckingArtist ? 'Checking Artist...' : 'I am this artist'}
			</button>
		</div>
	)	
}


class FindMe extends Component {
	state = {
		countryStates: CountryStates,
		countries: Countries
	}
	submitFindMe = (values) => {
		const { first_name, last_name, mobile_number, email } = values
		
		const param = {
			first_name: first_name,
			last_name: last_name,
			email: email,
			phone: mobile_number
		}
		return this.props.searchArtist(param)
	}

	getStateById = (id) => {
		const { countryStates } = this.state
		if (!id) return '';
		return countryStates.find(state => state.id == id).name
	}

	getCountryByCode = (code) => {
		const { countries } = this.state
		if (!code) return '';
		return countries.find(country => country.code == code).name
	}

	componentWillUnmount() {
		this.props.onUnload()
	}

	render() {
		const { errors, artist, artists, checkArtist, isCheckingArtist, projectId } = this.props

		if (artists && artists.length) {

			return (
				<div className="row">
					<h2>FIND ME</h2>
					<h6 className="subheader">Potential matches</h6>
					<div className="small-12 small-centered columns text-center">
						<div className="row small-up-2 medium-up-3 large-up-4">
						{ artists.map(artist => 
								<ShowArtistSelection 
									key={artist.id}
									isCheckingArtist={isCheckingArtist} 
									checkArtist={checkArtist}
									getCountryByCode={this.getCountryByCode}
									getStateById={this.getStateById}
									artist={artist} 
									{...this.props} />)}
						</div>
					</div>
				</div>
			)
		}

		return (
			<div className="row">
				
				<h2>Find Me</h2>
				<h6 className="subheader">Or please enter your basic information below</h6>
				
				<div className="small-12 medium-6 large-4 small-centered column">
					<FindMeForm 
						onSubmit={this.submitFindMe}
						artist={ artist || artists }
						errors={errors} />
				</div>				
			</div>
		)

	}
}


const mapStateToProps = state => ({
	...state.artist
})

const mapDispatchToProps = dispatch => ({
  searchArtist: payload =>
  	dispatch({ type: 'SEARCH_ARTIST', payload: agent.Artist.search(payload) }),
  onUnload: () => 
  	dispatch({type: 'FINDME_UNLOAD'}),
});

export default connect(mapStateToProps, mapDispatchToProps)(FindMe);




// WEBPACK FOOTER //
// ./src/components/FindMe.js